module.exports = __webpack_public_path__ + "img/image (19).e3631ca8.jpg";